var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.5C5.44772 2.5 5 2.94772 5 3.5V4.5H4C2.89543 4.5 2 5.39543 2 6.5V16.5C2 17.6046 2.89543 18.5 4 18.5H16C17.1046 18.5 18 17.6046 18 16.5V6.5C18 5.39543 17.1046 4.5 16 4.5H15V3.5C15 2.94772 14.5523 2.5 14 2.5C13.4477 2.5 13 2.94772 13 3.5V4.5H7V3.5C7 2.94772 6.55228 2.5 6 2.5ZM6 7.5C5.44772 7.5 5 7.94772 5 8.5C5 9.05228 5.44772 9.5 6 9.5H14C14.5523 9.5 15 9.05228 15 8.5C15 7.94772 14.5523 7.5 14 7.5H6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.592f2ad26315a17f530903e2bcc526e7.svg";
export { ForwardRef as ReactComponent };